import * as types from './type'
import * as api from './api'

export default {
  state: {
    avatar: '',
    balance: 0.000,
    idfa: '4B3B4EDE-0718-4095-8611-311B096A4D12',
    running: [{
      adv_id: 1,
      app_price: 0.00,
      appid: 395096736,
      created_at: 'Tue, 16 Oct 2018 15:19:31 GMT',
      end_at: 'Mon, 17 Dec 2018 18:30:00 GMT',
      icon: 'https://is1-ssl.mzstatic.com/image/thumb/Purple128/v4/c3/63/86/c3638680-bfcc-57df-5e05-1e2324a2d081/source/60x60bb.jpg',
      id: 3,
      name: '\u53bb\u54ea\u513f\u65c5\u884c-\u673a\u7968\u9152\u5e97\u706b\u8f66\u7968\u548c\u95e8\u7968\u9884\u8ba2',
      overtime: 600,
      playtime: 60,
      remain_num: 2952,
      reward: 1.000,
      start_at: 'Tue, 16 Oct 2018 15:26:00 GMT',
      status: 3,
      total: 3000,
      updated_at: 'Sat, 20 Oct 2018 11:51:05 GMT',
      user_doing: 0
    }, {
      adv_id: 1,
      app_price: 0.00,
      appid: 737310995,
      created_at: 'Thu, 18 Oct 2018 13:41:52 GMT',
      end_at: 'Wed, 31 Oct 2018 00:00:00 GMT',
      icon: 'https://is3-ssl.mzstatic.com/image/thumb/Purple118/v4/f9/7e/d9/f97ed99b-4cb8-4b10-4975-3627b4c3b292/source/60x60bb.jpg',
      id: 5,
      name: '\u7f8e\u56e2\u5916\u5356-\u5916\u5356\u8ba2\u9910,\u9001\u5565\u90fd\u5feb',
      overtime: 300,
      playtime: 30,
      remain_num: 994,
      reward: 1.000,
      start_at: 'Thu, 18 Oct 2018 12:00:00 GMT',
      status: 3,
      total: 1000,
      updated_at: 'Thu, 18 Oct 2018 13:42:31 GMT',
      user_doing: 0
    }, {
      adv_id: 1,
      app_price: 0.00,
      appid: 598853342,
      created_at: 'Mon, 22 Oct 2018 13:34:03 GMT',
      end_at: 'Mon, 29 Oct 2018 00:00:00 GMT',
      icon: 'https://is3-ssl.mzstatic.com/image/thumb/Purple118/v4/47/6d/c6/476dc69d-ac2b-3c60-9161-4acd63bfb178/source/60x60bb.jpg',
      id: 6,
      name: 'BOXFiSH\u76d2\u5b50\u9c7c\u82f1\u8bed',
      overtime: 300,
      playtime: 10,
      remain_num: 984,
      reward: 1.000,
      start_at: 'Mon, 22 Oct 2018 00:00:00 GMT',
      status: 3,
      total: 1000,
      updated_at: 'Mon, 22 Oct 2018 13:34:27 GMT',
      user_doing: 0
    }],
    team_member_num: 0,
    team_money: 0.000,
    uid: 9,
    upcoming: [{
      adv_id: 1,
      app_price: 0.00,
      appid: 1055208744,
      created_at: 'Wed, 17 Oct 2018 17:12:49 GMT',
      end_at: 'Tue, 18 Dec 2018 00:00:00 GMT',
      id: 4,
      name: '\u5b89\u798f\u901a-\u8386\u7530\u7535\u5546\u8d27\u6e90',
      overtime: 300,
      playtime: 60,
      remain_num: 98,
      reward: 1.000,
      start_at: '\u660e\u65e5 20:30',
      status: 3,
      total: 100,
      updated_at: 'Thu, 18 Oct 2018 13:43:21 GMT'
    }],
    assistant_download_url: '',
    assistant_icon: ''
  },
  mutations: {
    shoutuState (state, obj) {
      state[obj.key] = obj.val
    }
  },
  actions: {
    async [types.URI_ASSISTALIVE] ({ commit }, params) {
      let res = await api.assistalive(params)
      if (res && res.status === 200) {
        commit('shoutuState', { key: 'assistant_download_url', val: res.data.payload.open_url })
        commit('shoutuState', { key: 'assistant_icon', val: res.data.payload.icon })
      }
      return res
    }
  }
}
